(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-decorative-image"] && !window.DesignMode) return;
  try {
    
// Force section to have zero height after page load
document.addEventListener('DOMContentLoaded', function() {
  var decorSections = document.querySelectorAll('.shopify-section:has(.decorative-image-wrapper)');
  decorSections.forEach(function(section) {
    section.style.height = '0';
    section.style.padding = '0';
    section.style.margin = '0';
    section.classList.add('section-decorative-image-wrapper');
  });
});

  } catch(e) { console.error(e); }
})();
})();
